import React, { useEffect } from "react";
import { useGetApplicationQuery, usePostUpsertApplicationMutation } from "@/store/service";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ApplicationStep } from "@/enum/ApplicationStep";
import ApplicantAssets from "@/model/interface/ApplicantAssets";
import ApplicantAssetsForm from "./ApplicantAssets";
import { isDebugForms, getDebugNextStepUrl } from "@/util/debug";
import { assetsSchema } from "@/model/schemas";
import { zodFormResolver } from "@/util/form";

const ApplicantAssetsWrapper = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { data: application } = useGetApplicationQuery(params.id!);
  const [postApplication, postApplicationResult] = usePostUpsertApplicationMutation();

  const form = useForm<ApplicantAssets>({
    resolver: zodFormResolver<ApplicantAssets>(assetsSchema),
    mode: "onTouched",
    defaultValues: {
      residence: "0",
      otherProperty: "0",
      householdContents: "0",
      carBoatsBikesCaravans: "0",
      savingsOffsetAccountBalance: "0",
      otherAssets: "0",
      grossYearlyIncome: 0,
      netMonthlyIncome: 0,
      rentalIncome: 0,
      parentingAllowance: 0,
      pensionIncome: 0,
    },
  });
  const { handleSubmit, getValues } = form;

  useEffect(() => {
    if (postApplicationResult.isSuccess) {
      navigate(`/application/${postApplicationResult.data.id}/${postApplicationResult.data.step}`);
    }
  }, [postApplicationResult.isSuccess]);

  const onSubmit = async (data: ApplicantAssets) => {
    await postApplication({ assets: data, id: params.id!, step: ApplicationStep.ApplicantAssets });
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isDebugForms()) {
      navigate(getDebugNextStepUrl(params.id!, ApplicationStep.ApplicantAssets, params.type));
    } else {
      handleSubmit(onSubmit)(e);
    }
  };

  return (
    <form onSubmit={handleFormSubmit} className="relative">
      <div className="w-full max-w-2xl mx-auto space-y-5">
        <h3 className="text-2xl font-semibold text-gray-900 text-center">Assets & Income</h3>
        <ApplicantAssetsForm form={form} />
        <div className="flex justify-center pt-2">
          <button
            type="submit"
            name="submit"
            className="inline-flex items-center rounded-full bg-[#9BFBE0] px-8 py-3 text-sm font-medium text-[#010305] shadow-sm hover:shadow-md transition-all"
          >
            Continue
          </button>
        </div>
      </div>
    </form>
  );
};

export default ApplicantAssetsWrapper;
